import HRView from "./HRViewV2";

export default HRView;
